<template>
	<div class="content">
		<div class="left">
			 <el-menu
			      :default-active="activeIndex"
			      class="el-menu-vertical-demo"
				  @select="handleSelect">
			      <el-menu-item index="1">
			        <span class="left-nav-text">衡水小金</span>
					<span class="left-nav-icon">></span>
			      </el-menu-item>
			      <el-menu-item index="2">
			        <span class="left-nav-text">政策咨询</span>
			        <span class="left-nav-icon">></span>
			      </el-menu-item>
			      <el-menu-item index="3">
			        <span class="left-nav-text">投诉建议</span>
			        <span class="left-nav-icon">></span>
			      </el-menu-item>
				  <el-menu-item index="4">
				    <span class="left-nav-text">贷款试算</span>
				    <span class="left-nav-icon">></span>
				  </el-menu-item>
				  <el-menu-item index="5">
				    <span class="left-nav-text">操作指南</span>
				    <span class="left-nav-icon">></span>
				  </el-menu-item>
				  <el-menu-item index="6" v-if="false">
				    <span class="left-nav-text">查询楼盘</span>
				    <span class="left-nav-icon">></span>
				  </el-menu-item>
				  <el-menu-item index="7" v-if="false">
				    <span class="left-nav-text">曝光台</span>
				    <span class="left-nav-icon">></span>
				  </el-menu-item>
				  <el-menu-item index="8" v-if="false">
				    <span class="left-nav-text">统计信息</span>
				    <span class="left-nav-icon">></span>
				  </el-menu-item>
			    </el-menu>
		</div>
		<div class="right">
			<!-- 衡水小金 -->
			<div v-show="activeIndex == 1" >
				<div class="list" v-loading="loading_5529_22">
					<ul>
						<li v-for="item in hsxjList" @click="tonews(5529,item.seqno)">
							<span class="text">{{ item.title |ellipsis(50) }}</span>
							<span class="time">[{{ item.releasetime|formatTime('YYYY-MM-DD')}}]</span>
						</li>
					</ul>
					<el-pagination
						v-show="hsxjtotal!=0"
					  background
					  layout="total,prev, pager, next"
					  @current-change="handleCurrentChange('5529',$event,'22')"
					  :total="hsxjtotal">
					</el-pagination>
				</div>
			</div>
			<!-- 政策咨询 -->
			<div v-show="activeIndex == 2" >
				<div v-loading="loading_zczx" class="questions">
					<div class="seach">
						<el-input style="width: 200px;" v-model="zczxseach" placeholder="请输入关键词">
						</el-input><el-button type="primary" @click="seach(zczxseach)">搜索</el-button>
					</div>
					
					<ul>
						<li v-for="item in zczxList">
							<el-descriptions :title="item.information">
							    <el-descriptions-item label="回复内容">{{item.return_info}}</el-descriptions-item>
							</el-descriptions>
							<el-divider></el-divider>
						</li>
					</ul>
					<el-pagination
					v-show="zczxtotal!=0"
					  background
					  layout="total,prev, pager, next"
					  :page-size="5"
					  :currentPage.sync="pageNum"
					  @current-change="zczxhandleCurrentChange($event)"
					  :total="zczxtotal">
					</el-pagination>
				</div>
			</div>
			<!-- 投诉建议 -->
			<div v-show="activeIndex == 3">
				<el-form ref="formdata" :rules="rules" :model="formdata" label-width="80px" style="margin-top: 20px;">
				  <el-form-item label="姓名" prop="name" style="width: 300px;">
				    <el-input placeholder="请输入姓名"  v-model="formdata.name"></el-input>
				  </el-form-item>
				  <el-form-item label="联系电话" prop="phone" style="width: 300px;">
				    <el-input placeholder="请输入联系方式" v-model="formdata.phone"></el-input>
				  </el-form-item>
				  <el-form-item label="内容"  prop="content" style="width: 500px;">
				      <el-input 
						placeholder="请输入投诉内容或建议" 
						type="textarea" 
						v-model="formdata.content"
						:autosize="{ minRows: 3, maxRows: 4}"
						maxlength="200"
						show-word-limit
					  ></el-input>
				    </el-form-item>
					<el-form-item>
					    <el-button type="primary" @click="submitForm('formdata')">提交</el-button>
					    <el-button @click="resetForm('formdata')">重置</el-button>
					  </el-form-item>
				</el-form>
			</div>
			<!-- 贷款试算 -->
			<div v-show="activeIndex == 4">
				<loan></loan>
			</div>
			<!-- 操作指南 -->
			<div v-show="activeIndex == 5" >
				<div class="list" v-loading="loading_5600_21">
					<ul>
						<li v-for="item in czznList" @click="tonews(5501,item.seqno)">
							<span class="text">{{ item.title |ellipsis(50)}}</span>
							<span class="time">[{{ item.releasetime|formatTime('YYYY-MM-DD')}}]</span>
						</li>
					</ul>
					<el-pagination
					v-show="czzntotal!=0"
					  background
					  layout="total,prev, pager, next"
					  @current-change="handleCurrentChange('5600',$event,'21')"
					  :total="czzntotal">
					</el-pagination>
				</div>
			</div>
			<!-- 查询楼盘 -->
			<div v-show="activeIndex == 6">

			</div>
			<!-- 曝光台 -->
			<div v-show="activeIndex == 7">

			</div>
			<!-- 统计信息 -->
			<div v-show="activeIndex == 8">

			</div>
		</div>
	</div>
</template>

<script>
	import axios from "axios";
	import loan from './loan.vue';
	import qs from 'qs';
	export default {
		components: {
		    loan
		},
		data() {
			return{
				activeIndex:"1",
				hsxjList:[],
				hsxjtotal:0,
				loading_5529_22:true,
				zczxList:[],
				zczxtotal:0,
				zczxseach:"",
				loading_zczx:true,
				pageNum:1,
				formdata:{
					name:"",
					phone:"",
					content:""
				},
				czznList:[],
				czzntotal:0,
				loading_5600_21:true,
				rules: {
				  name: [
					{ required: true, message: '请输入姓名', trigger: 'blur' },
				  ],
				  phone: [
					{ required: true, message: '请输入联系方式', trigger: 'blur' },
					{ required: true, pattern:/^1[3-9]\d{9}$|^0\d{2,3}-\d{7,8}$/, message: '请输入正确联系方式', trigger: 'blur'}
				  ],
				  content: [
					{ required: true, message: '请填写投诉内容或建议', trigger: 'blur' }
				  ]
				}
			}
		},
		filters: {//限制文本显示字数,超出部分用...代替
		    ellipsis (value,index) {
		      if (!value) return ''
		      if (value.length > index) {
		        return value.slice(0,index) + '...'//0:下标,从第一个字开始显示,50:显示字数,多余用...代替
		      }
		      return value
		    },
			formatTime(value, format = 'YYYY-MM-DD') {
			    if (!value) return '';
			      const date = new Date(value);
			      const options = {
			        'Y+': date.getFullYear().toString(),        // 年
			        'M+': (date.getMonth() + 1).toString(),      // 月
			        'D+': date.getDate().toString(),             // 日
			        'H+': date.getHours().toString(),            // 时
			        'm+': date.getMinutes().toString(),          // 分
			        'S+': date.getSeconds().toString()           // 秒
			        // 可以继续添加其他格式化选项
			      };
			      for (let k in options) {
			        const reg = new RegExp(`(${k})`);
			        if (reg.test(format)) {
			          format = format.replace(reg, options[k].length === 1 ? `0${options[k]}` : `${options[k]}`);
			        }
			      }
			      return format;
			  },
		},
		watch:{
			'$route.query.activeIndex': function(newValue, oldValue) {
			      this.activeIndex=newValue
			    }
			
		},
		created(){
			if(this.$route.query.activeIndex<15&&this.$route.query.activeIndex>0){
				this.activeIndex=this.$route.query.activeIndex
			}
			// 衡水小金
			// this.getList("0","5529","22");
			// 衡水小金
			this.getList("0","5529","22");
			// 操作指南
			this.getList("0","5600","21");
			// // 曝光台
			// this.getList("0","5602","13");
			// // 统计信息
			// this.getList("0","5600","12");
			this.getzczx('','1')
		},
		methods: {
			handleSelect(index){
				if(this.$route.query.activeIndex!==index){
					this.$router.push({path:'/quick?activeIndex='+index}) 
				}
			},
			getList(pagenum,buzType,parentViewItemId){
				  axios.post("/token/admin/huaxin/index",qs.stringify({
				  	data:{"buzType":buzType,"keyword":"","parentViewItemId":parentViewItemId,"pagenum": pagenum,"pagerows":"10",},
				  	url:"appapi70009.json"
				  }))
				  .then(response => {
					  switch(buzType,parentViewItemId){
						  // 衡水小金
						  case ("5529","22"):
						  this.hsxjList = response.data.result.news.newsList
						  this.hsxjtotal=response.data.result.news.total
						  this.loading_5529_22=false
						  break;
						  // 操作指南
						  case ("5600","21"):
						  this.czznList = response.data.result.news.newsList
						  this.czzntotal=response.data.result.news.total
						  this.loading_5600_21=false
						  break;
						  // 曝光台
						  case ("5602","13"):
						  this.bgtList = response.data.result.news.newsList
						  this.bgttotal=response.data.result.news.total
						  break;
						  // 统计信息
						  case ("5600","12"):
						  this.tjxxList = response.data.result.news.newsList
						  this.tjxxtotal=response.data.result.news.total
						  break;
					  }
					  
				  })
				  .catch(function(error) {
				    console.log(error);
				  });
			},
			// 获取政策咨询
			getzczx(key,currentPage){
				axios.post("/token/admin/huaxin/index",qs.stringify({
					ly:"1",
					data:{"key":key,"isreturn":"true","currentPage":currentPage,"pageSize": "5"},
					url:"appapi90412.json"
				}))
				.then(response => {
					this.zczxList=response.data.datas
					this.zczxtotal=response.data.totalCount
					this.loading_zczx=false
				})
				.catch(function(error) {
					// 请求失败处理
					console.log(error);
				});
			},
			seach(){
				this.loading_zczx=true
				this.pageNum=1;
				this.getzczx(this.zczxseach,'1');
			},
			tonews(buztype,titleid){
				this.$router.push({path:'/new_details',query: {buzType:buztype,titleId:titleid}}) 
			},
			handleCurrentChange(buzType,pagenum,parentViewItemId) {
				this.$set(this,'loading_'+buzType+'_'+parentViewItemId,true)
				this.getList(pagenum-1,buzType,parentViewItemId);
			},
			// 政策咨询带参数翻页
			zczxhandleCurrentChange(currentPage){
				this.loading_zczx=true
				this.getzczx(this.zczxseach,currentPage)
			},
			// 提交投诉建议
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
				  if (valid) {
					axios.post("/token/admin/huaxin/index",qs.stringify({
						ly:"1",
						typez:"2",
						data:{"information":this.formdata.content,"user_name":this.formdata.name,"currentPage":this.formdata.phone,"img_urls":""},
						url:"appapi90411.json"
					}))
					.then(response => {
						alert('留言成功！')
						this.resetForm('formdata');
					})
					.catch(function(error) {
						alert('留言失败！')
					});
				  }
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			}
		}
	}
</script>

<style scoped>
	.content{
		padding-bottom: 20px;
		display: flex;
		background-color: #ffffff;
	}
	.left{
		width: 250px;
		min-height: 400px;
		background-color: #ffffff;
	}
	.right{
		width: 930px;
		min-height: 400px;
		margin: 0 20px;
	}
	.list{
		min-height: 330px;
	}
	.right .list li{
		height: 32px;
		line-height: 32px;
		text-align: left;
		list-style-type: none;
		border-bottom: 1px dashed #999
	}
	.right .list li .text:hover{
		cursor: pointer;
		color: red;
	}
	.questions{
		min-height: 400px;
	}
	.right .questions li{
		list-style-type: none;
		padding-right: 20px;
	}
	.right .time{
		float: right;
		margin-right: 4px;
		font-size: 12px;
		color: #999;
	}
	.seach{
		height: 50px;
		display: flex;
		align-items: center;
		justify-content: end;
		margin: 10px 20px;
	}
	
	.el-menu-vertical-demo span{
		margin-left: 10px;
	}
	.el-menu-item{
		font-size: 18px	;
		margin:0 10px;
		border-bottom: 1px solid #c8c8c8;
	}
	.left-nav-icon{
		float: right;
	}
	.el-pagination{
		text-align: right;
	}
	.el-divider--horizontal{
		margin: 12px 0;
	}
</style>